<template>
    <el-dialog title="报警详情" custom-class="accident" :close-on-click-modal="false" :modal-append-to-body="false"
        :visible="dialogVisible" @close="close">
        <div class="container" v-loading="status === 'loading'" v-if="status === 'loading'"></div>
        <div class="container" v-else>
            <div class="infomation">
                <div class="image-wapper">
                    <img :src="infomation.img" alt="">
                    <div>{{infomation.deviceName}}</div>
                </div>
                <div class="description">
                    <div class="description-title">
                        <div>{{infomation.name}}-{{infomation.type}}</div>
                        <span>编号：{{infomation.code}}</span>
                    </div>
                    <div class="separate"></div>
                    <div class="description-content" id="accidentRadio">
                        <div>事件分类：{{infomation.classify | mapper}}</div>
                        <div>位置信息：{{infomation.position}}</div>
                        <div>发生时间：{{infomation.start | dateFormat}}</div>
                        <div>结束时间：{{infomation.end | dateFormat}}</div>
                        <div>报警描述：{{infomation.description}}</div>
                        <div v-if="infomation.check !== undefined">确认状态：
                            <el-radio disabled v-model="radio" label='false' @change="change">未确认</el-radio>
                            <el-radio v-model="radio" label='true' @change="change">已确认</el-radio>
                            <span v-if="infomation.check && showName">确认人：{{infomation.realName}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="data" v-if="infomation.classify !== 'EQUIPMENT_FAILURE' &&infomation.classify !== 'TELEMETRY_OVERRUN'&& data.length > 0">
                <div class="data-title">发生时刻电力数据：</div>
                <div class="data-content">
                    <PointItem v-for="(item, index) in data" :key="index" :item="item" />
                    <span class="separate"></span>
                </div>
            </div>
              <div class="data" v-if="infomation.classify == 'TELEMETRY_OVERRUN'&& data.length > 0">
                <div class="data-title">越限时刻运行状态：</div>
                <div class="data-content">
                    <Transformer v-for="(item, index) in data" :key="index" :item="item"></Transformer>
                    <span class="separate"></span>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import PointItem from './shared/PointItem';
    import Transformer from './shared/transformer';
    import {
        dateFormat
    } from '../../util/DateUtil';

    const TYPES = {
        TELEMETRY_OVERRUN: '越限异常',
        EQUIPMENT_FAILURE: '网关离线',
        TELEMETRY_DISPLACEMENT: '跳闸报警',
        // DEVICE_EXCEPTION: '设备异常',
         DEVICE_FAILURE: '设备异常',
    }

    export default {
        props: {
            dialogVisible: Boolean,
            status: String,
            detail: Object,
        },
        data() {
            return {
                loading: false,
                changeState: false,
                showName: true
            }
        },
        components: {
            PointItem,
            Transformer
        },
        // mounted() {
        //     console.log(this.infomation)
        // },
        methods: {
            close() {
                this.$emit('closeDetail', this.infomation.code, this.infomation.check, this.changeState)
            },
            change(value) {
                this.detail.infomation.check = true
                this.changeState = true
                this.showName = false
            }
        },
        watch: {},
        computed: {
            infomation: function () {
                return this.detail && this.detail.infomation || {};
            },
            data: function () {
                // debugger
                 console.log(this.detail)
                return this.detail && this.detail.data || [];
            },
            radio: {
                get() {
                    return this.detail && this.detail.infomation.check.toString()
                },
                set(value) {
                    return value
                }
            }
        },
        filters: {
            mapper: function (value) {
                //console.log(value, TYPES[value]);
                return TYPES[value] || '未知事件';
            },
            dateFormat: function (value) {
                if (!value) {
                    return '--';
                }
                return dateFormat('YYYY年mm月dd日 HH:MM', new Date(value));
            }
        }
    }
</script>

<style lang="less" scoped>
    .container {
        display: flex;
        .h(595);
        flex-direction: column;
        background: rgba(0, 43, 102, 0.02);
    }

    /deep/ .el-dialog__body {
        border-top: 1px solid rgba(0, 0, 0, 0.1) !important
    }
 /deep/ .el-dialog__header{
    padding: 0 0 0 20rem !important;
}
    .infomation {
        padding: 24rem;
        display: flex;
        flex-direction: row;
        .h(385);
        background: #ffffff;
        .image-wapper {
            .h(337);
            .w(360);
            border: 1px solid #EEEEEE;
            display: flex;
            flex-direction: column;
            justify-content: center;

            img {
                display: block;
                width: 300rem;
                margin: 0 auto;
            }

            div {
                text-align: center;
            }
        }

        .description {
            .w(576);

            .description-title {

                div {
                    font-size: 24rem;
                    font-weight: bold;
                    color: #333333;
                }

                span {
                    font-size: 16rem;
                    font-weight: 400;
                    color: #999999;
                    margin-top: 14rem;
                    display: block;
                    margin-bottom: 24rem;
                }
            }

            .separate {
                height: 1px;
                background: rgba(0, 0, 0, 0.06)
            }

            .description-content {
                display: flex;
                flex-flow: column nowrap;

                div {
                    font-size: 16rem;
                    font-weight: 400;
                    color: #666666;
                    margin-top: 14rem;
                }
            }
        }
    }

    .description {
        margin-left: 48rem;
    }

    .data {
        padding: 24rem;
        background: rgba(0, 43, 102, 0.02);
        width: 100%;
        .h(200);
        // height: 182px;
        .data-title {
            font-size: 16rem;
            font-weight: bold;
            color: #333333;
        }

        .data-content {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            flex-wrap: wrap;
            max-height: 99%;
            width: 50%;

            .separate {
                margin: 0;
                width: 1px;
                height: 132rem;
                background: rgba(0, 0, 0, 0.15);
                position: absolute;
                left: 48%;
            }

        }
    }
</style>